/**
 * Generated template: Pets
 * Auto-generated by scripts/generate-templates.js - DO NOT EDIT
 */

import { TierListTemplate, Tier } from "@/types/tier-list";
import { TemplateMetadata } from "@/types/template-metadata";

/**
 * Template metadata (available immediately, no images loaded)
 */
export const metadata: TemplateMetadata = {
  id: "hvh-pets",
  displayName: "Pets",
  groupName: "Heroes vs Hordes",
  description: "Tier list for \"Heroes vs Hordes\" pets",
  tiers: [
  {
    "id": "6d0c77a4-a9b2-4eac-8b82-e9146a6b05e9",
    "label": "S+",
    "priority": 0,
    "color": {
      "label": "#000000",
      "background": "#FCD34D"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "9aa7f5c2-85e6-4aa9-9594-88338a863f8f",
    "label": "S",
    "priority": 1,
    "color": {
      "label": "#FFFFFF",
      "background": "#7C3AED"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "a4bf0b2c-2ef1-449c-8b6f-97dedadb4745",
    "label": "A",
    "priority": 2,
    "color": {
      "label": "#FFFFFF",
      "background": "#2563EB"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "147d8554-3b3a-402d-9652-15303b224478",
    "label": "B",
    "priority": 3,
    "color": {
      "label": "#FFFFFF",
      "background": "#16A34A"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "c3174b4e-58c4-4cd3-8dc5-243dbe2c7ec6",
    "label": "C",
    "priority": 4,
    "color": {
      "label": "#FFFFFF",
      "background": "#EA580C"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "9d7bc9df-1ae9-4c1f-b0c1-cf0a19b4af3d",
    "label": "D",
    "priority": 5,
    "color": {
      "label": "#FFFFFF",
      "background": "#DC2626"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "2d21ec53-e0ef-401c-a9a8-bb8cefcd12ce",
    "label": "F",
    "priority": 6,
    "color": {
      "label": "#FFFFFF",
      "background": "#64748B"
    },
    "fontSizeMultiplier": 2
  }
] as Tier[],
  hasItems: true,
};

/**
 * Load full template with all data including images
 * This is lazy-loaded only when the template is selected
 */
export async function loadFull(): Promise<TierListTemplate> {
  // Dynamic import loads the full JSON only when called
  const fullTemplate = await import("@/templates/hvh-pets.json");
  return fullTemplate.default as TierListTemplate;
}
